import React, {useState, useRef} from 'react';
import {
    Button, Col, FormGroup, Input, Label, Row, Alert, Spinner,
} from 'reactstrap';
import {useTranslation} from 'react-i18next';
import {useFormik} from 'formik';
import * as Yup from 'yup';
import {appConfig} from '../../config';

const Support = () => {
    const {t} = useTranslation();
    const [alert, setAlert] = useState({type: '', message: '', visible: false});
    const alertTimeoutRef = useRef(null);

    const showAlert = (type, message) => {
        if (alertTimeoutRef.current) clearTimeout(alertTimeoutRef.current);
        setAlert({type, message, visible: true});
        alertTimeoutRef.current = setTimeout(() => {
            setAlert(prev => ({...prev, visible: false}));
        }, 6000);
    };

    const formik = useFormik({
        initialValues: {
            name: '', email: '', subject: '', message: '',
        }, validationSchema: Yup.object({
            name: Yup.string().required(t('name_required')),
            email: Yup.string().email(t('email_invalid')).required(t('email_required')),
            subject: Yup.string().required(t('subject_required')),
            message: Yup.string().required(t('message_required')).min(5, t('message_min')),
        }), onSubmit: async (values) => {
            try {
                const url = appConfig.baseUrl + appConfig.api.contactUrl;

                const response = await fetch(url, {
                    method: 'POST', headers: {
                        'Content-Type': 'application/json', login: 'HRplus+', password: 'Ctc0oTYayc77z',
                    }, body: JSON.stringify(values),
                });

                const data = await response.json();

                if (data.success === true) {
                    showAlert('success', t('alert_success'));
                } else {
                    let errorMsg = '';

                    if (data.message) {
                        errorMsg = data.message;
                    } else if (data.errors && Array.isArray(data.errors)) {
                        errorMsg = data.errors.map(e => `${e.field}: ${e.message}`).join('\n');
                    } else {
                        errorMsg = t('alert_error');
                    }

                    showAlert('danger', errorMsg);
                }
            } catch (error) {
                console.error('Tarmoq xatoligi:', error);
                showAlert('danger', t('alert_error'));
            }
        },
    });

    return (<div className="page-content">
            <div className="container">
                <h2>{t('contact_us')}</h2>
                <p>{t('contact_instruction')}</p>

                {alert.visible && <Alert color={alert.type}>{alert.message}</Alert>}

                <Row>
                    <Col md={8} xl={6}>
                        <form noValidate onSubmit={formik.handleSubmit}>
                            <FormGroup>
                                <Label htmlFor="name">
                                    {t('name')} <span className="text-danger">*</span>
                                </Label>
                                <Input
                                    type="text"
                                    name="name"
                                    placeholder={t('name_placeholder')}
                                    value={formik.values.name}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    invalid={formik.touched.name && !!formik.errors.name}
                                />
                                {formik.touched.name && formik.errors.name && (
                                    <div className="text-danger">{formik.errors.name}</div>)}
                            </FormGroup>

                            <FormGroup>
                                <Label htmlFor="email">
                                    {t('email')} <span className="text-danger">*</span>
                                </Label>
                                <Input
                                    type="email"
                                    name="email"
                                    placeholder={t('email_placeholder')}
                                    value={formik.values.email}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    invalid={formik.touched.email && !!formik.errors.email}
                                />
                                {formik.touched.email && formik.errors.email && (
                                    <div className="text-danger">{formik.errors.email}</div>)}
                            </FormGroup>

                            <FormGroup>
                                <Label htmlFor="subject">
                                    {t('subject')} <span className="text-danger">*</span>
                                </Label>
                                <Input
                                    type="text"
                                    name="subject"
                                    placeholder={t('subject_placeholder')}
                                    value={formik.values.subject}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    invalid={formik.touched.subject && !!formik.errors.subject}
                                />
                                {formik.touched.subject && formik.errors.subject && (
                                    <div className="text-danger">{formik.errors.subject}</div>)}
                            </FormGroup>

                            <FormGroup>
                                <Label htmlFor="message">
                                    {t('message')} <span className="text-danger">*</span>
                                </Label>
                                <Input
                                    type="textarea"
                                    name="message"
                                    placeholder={t('message_placeholder')}
                                    value={formik.values.message}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    invalid={formik.touched.message && !!formik.errors.message}
                                />
                                {formik.touched.message && formik.errors.message && (
                                    <div className="text-danger">{formik.errors.message}</div>)}
                            </FormGroup>

                            <div className="d-flex align-items-center gap-3">
                                <Button
                                    color="success"
                                    type="submit"
                                    disabled={formik.isSubmitting}
                                >
                                    {formik.isSubmitting && <Spinner size="sm" className="me-2"/>}
                                    {t('send')}
                                </Button>

                                <Button
                                    color="danger"
                                    type="button"
                                    onClick={() => formik.resetForm()}
                                    disabled={formik.isSubmitting}
                                >
                                    {t('cleaning')}
                                </Button>

                            </div>
                        </form>
                    </Col>
                </Row>
            </div>
        </div>);
};

export default React.memo(Support);
